import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service';
import { Subscription } from 'rxjs';  


@Component({
  selector: 'app-managerteamwisecall',
  template: require('./managerteamwisecall.component.html'),
  styles: []
})
export class ManagerTeamWiseCallComponent implements OnInit {

  expDetails: any;
  private columnDefs;
  private rowData;
  private rowHeight;
  api: any;
  busy: Subscription;
  columnApi: any;
  defaultColDefine;
  private gridColumnApi;
  private detailCellRendererParams;
  currentMonth: any;

  staffTypes: any;
  staff: any;
  designation: any;
  currentDate: any;


  static parameters = [ApiService]

  constructor(
    private apiService: ApiService

  ) {
    this.columnDefs = [
      { headerName: 'Date', field: 'sno' },
      { headerName: 'Amarpal Singh', field: "Manager" },
      { headerName: 'Kompal Kaur', field: "hdqtr" },
      { headerName: 'Narender Singh', field: "Employee" },
      { headerName: 'Vipin Dogra', field: "StaffType" },
      { headerName: 'Call Date', field: "CallDate" },
      { headerName: 'Ashutosh Sharma', field: "Month" },
      { headerName: 'Omkan Singh', field: "JWWith" },
      { headerName: 'Prasant Kumar', field: "Route" }
    ];
    this.defaultColDefine = { resizable: true };
    this.rowData = [
      { sno: '02/02/2021', Manager: 'Meeting', hdqtr: '', Employee: 'Sector - 5, Noida', StaffType: 'Meeting', CallDate: 'Paryagraj To Kareli', Month: 'Paryagraj To Kareli', JWWith: 'Paryagraj To Kareli', Route: "Paryagraj To Kareli" }
    ];
    this.rowHeight = 50;
  }
  ngOnInit() {
  }
}
